import { useSearch } from "@usereactify/search";
import { useEffect, useState } from "react";

export const useSearchArticles = () => {
  const [searchResults, setSearchResults] = useState<UseSearchArticles | undefined>();
  const { searchTerm } = useSearch();

  /* using Predictive Search API reference */
  useEffect(() => {
    searchTerm &&
      fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=article`)
        .then((response) => response.json())
        .then((suggestions) => {
          setSearchResults(suggestions);
        });
  }, [searchTerm, setSearchResults]);

  return searchResults;
};
interface UseSearchArticles {
  resources: {
    results: { articles: Array<Article> };
  };
}

interface Article {
  author: string;
  body: string;
  featured_image: {
    alt: string;
    aspect_ratio: number;
    height: number;
    url: string;
    width: number;
  };
  handle: string;
  id: number;
  image: string;
  published_at: string;
  summary_html: string;
  tags: [];
  title: string;
  url: string;
}
